import { MDBSpinningPreloader } from 'src/app/services/modal.service';
import { environment } from 'src/environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { APP_ROUTING } from './app.routes';

import { UserService } from './services/user.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth-interceptor';

import { DataService } from "./shared/data-service/data.service.service";

import { HttpClient } from '@angular/common/http';

import { ThemeService } from './services/theme.service'

export function createTranslateLoader(http: HttpClient) {
  // TranslateHttpLoader v17 ya no recibe (http, prefix, suffix): loader inline
  return { getTranslation: (lang: string) => http.get('./assets/i18n/' + lang + '.json') } as any;
}

import { AppConfigService } from './app-config.service.service';
import { Service, PriorityData, TypeData } from 'src/app/services/app.service';

import { LoadingInterceptor } from './shared/LoadingInterceptor';
import { ErrorInterceptor } from './shared/ErrorInterceptor';
import { CurrencyPipe, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranlationConfigModule } from './tranlation-config/tranlation-config.module';
import { DevExtremeModule, DxSchedulerModule, DxTextBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from './shared/mdb-global.module';
import { NavbarSidebarModule } from './shared/navbar-sidebar/navbar-sidebar.module';
import { LoginRecoverPasswdCSComponent } from './pages/login-v2/login-recover-passwd-cs/login-recover-passwd-cs.component';
import { RegisterCubeShopUserComponent } from './pages/login-v2/login-v2/create-cubeshop-user/register-cubeshop-user.component';
import { ResponsiveComponent } from './pages/home/responsive/responsive.component';


import { AppConfiguration } from './config/app-configuration';
import {JsonAppConfigService} from './config/json-app-config.service';
import { TruncatePipe } from './custom-pipe/TruncatePipe';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { LoginCubeShopComponent } from './pages/login-v2/login-v2/login-cubeshop/login-cubeshop.component';

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

export function initializerFn(jsonAppConfigService: JsonAppConfigService){
  return () => {
    return jsonAppConfigService.load();
  };
}

@NgModule({ declarations: [
        AppComponent,
        LoginCubeShopComponent,
        LoginRecoverPasswdCSComponent,
        RegisterCubeShopUserComponent,
        ResponsiveComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA], imports: [DevExtremeModule,
        NavbarSidebarModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        MdbGlobalModule,
        TranlationConfigModule.forRoot(),
        APP_ROUTING,
        RecaptchaModule], providers: [
        CurrencyPipe,
        DatePipe,
        TruncatePipe,
        ThemeService,
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFn,
            multi: true,
            deps: [AppConfigService]
        },
        MDBSpinningPreloader,
        DataService,
        Service, PriorityData, TypeData,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        UserService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: AppConfiguration,
            deps: [HttpClient],
            useExisting: JsonAppConfigService
        },
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [JsonAppConfigService],
            useFactory: initializerFn
        },
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }))
    ] })
export class AppModule { }
